import React from "react";
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import {HOST} from "../../config";
import {Helmet} from "react-helmet";
import Servers from "../Servers";
import MaintenanceNotice from "../../components/Global/MaintenanceNotice";
import Footer from "../../components/Global/Footer";
import styled from "styled-components";

const PlatformContainer = styled.main`
  align-items: stretch;
  display: flex;
  padding: 2em 4em;
  flex-direction: column;
  justify-content: center;
  background-color: #101112;
`;

const ContentArea = styled.div`
  width: 100%;
  max-width: 95em;
`;

const MainContent = styled.div`
  width: 100%;
`;

export const Index = () => {
    // useEffect(() => {
    //     initMixpanel();
    //
    //     sendAnalyticsRequest('Landing Gacha / Load', {
    //         currentUrl: window.location.href
    //     });
    // }, []);

    return (
        <Router basename={HOST}>
            <Helmet
                link={[
                    {"rel": "icon", "href": `${HOST}images/favicons/favicon.ico`}
                ]}
            />

            <PlatformContainer>
              <ContentArea>
                <MainContent>
                  <MaintenanceNotice />

                  <Routes>
                    <Route path='/' element={<Navigate to={`/dm`} replace />} />
                    {/*<Route path={`:lang/`} element={<Modes />} />*/}
                    <Route path={`/:slug`} element={<Servers />} />
                    {/*<Route path={`/*`} element={<Error />} />*/}
                  </Routes>
                </MainContent>
                <Footer />
              </ContentArea>
            </PlatformContainer>
        </Router>
    );
};

export default Index;